import { TurnOrderTypes } from '../constants/turnorderConstants';

const openTurnOrder = () => ({
    type: TurnOrderTypes.OPEN_TURNORDER
});

const closeTurnOrder = () => ({
    type: TurnOrderTypes.CLOSE_TURNORDER
});

const toggleTurnOrder = () => ({
    type: TurnOrderTypes.TOGGLE_TURNORDER
});

const setTurnOrders = (items) => ({
    type: TurnOrderTypes.SET_TURNORDER,
    items
});

const setTurns = (num) => ({
    type: TurnOrderTypes.SET_TURNS,
    num
});

const addTurnOrder = (item) => ({
    type: TurnOrderTypes.ADD_TURNORDER,
    item
});

const deleteTurnOrder = (id) => ({
    type: TurnOrderTypes.REMOVE_TURNORDER,
    id
});

const editTurnOrder = (id, item) => ({
    type: TurnOrderTypes.EDIT_TURNORDER,
    id,
    item
});

export default {
    openTurnOrder,
    closeTurnOrder,
    toggleTurnOrder,
    setTurnOrders,
    setTurns,
    addTurnOrder,
    deleteTurnOrder,
    editTurnOrder
};